import { useQuery } from '@tanstack/react-query';
import { getChangelog } from '../api';
import { transmittersKeys } from './useTransmitters';

export function useTransmitterChangelog(id: string | null, enabled: boolean) {
  return useQuery({
    queryKey: transmittersKeys.changelog(id ?? ''),
    queryFn: () => getChangelog(id!),
    enabled: !!id && enabled,
    staleTime: 30 * 1000,
  });
}
